<template>
  <div>
    <h2 v-if="paymentStatus" class="stripe-payment-success">{{ message }}</h2>
    <h2 v-else class="stripe-payment-error">{{ message }}</h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '../../services.js';
export default {
  data() {
    return {
      profileData: null,
      paymentStatus: false,
      message: ''
    };
  },
  computed: {
    ...mapGetters({
        userToken: 'userToken',
        userRole: 'userRole',
        userClientID: 'userClientID',
        employeeId: 'employeeId',
        userRoleSlug: 'userRoleSlug',
        userID: 'userID',
        getNylasUserEmail: 'getNylasUserEmail'
    })
  }, 
  watch: {},
  methods: {
    async getEmpDetails() {
      // this.getBaseURL = global[0].IMAGE_URL;
      this.$Progress.start();
      await service.get('employee/' + this.employeeId, {
          'Authorization': this.userToken,
          'cs3-context-role': this.userRole,
          'cs3-context-clientId': this.userClientID
      })
      .then((res) => {
          this.profileData = res.data.result;
          this.paymentStatus = this.profileData.employable&&this.profileData.employable.stripe_subscription ? true : false;
      }).catch((err) => {
          console.log(err);
      });
    },
    async getEmailProvider() {
      await service.get('employee/detectNylasProvider', {
          'Authorization': this.userToken,
          'email': this.getNylasUserEmail
      }).then((res) => {
        if(res.data&&res.data.result&&res.data.result=='gmail') {  
          this.$router.push({
                path: "/sign-in-with-google",
                name: 'signInWithGoogle'
            });
        }else {
            this.generateNylasLink()
        }           
      }).catch((err) => {
          console.log(err);
      });
    },
    async generateNylasLink() {
      await service.get('employee/authorizeNylas', {
          'Authorization': this.userToken,
          'user-id': this.userID,
          'email': this.getNylasUserEmail
      }).then((res) => {
        if(res.data&&res.data.result) {          
          window.location.href = res.data.result;
          this.$notify({
            type: 'success',
            title: this.$t('success'),
            message: 'Your Nylas Subscription Started. Thank you for being with us!'
          });          
        }        
      }).catch((err) => {
          console.log(err);
      });
    }
  },
  async created() {
    try {
      await this.getEmpDetails();
      if(this.paymentStatus) {
        this.message = "Payment Success"
        await this.generateNylasLink();
        // await this.getEmailProvider();
      }else {
        this.message = "Sorry! We didn't received your payment yet. Please contact support team."
      }
      // this.generateNylasLink();
      // if(this.profileData && this.profileData.stripe_subscription) {
      // }
    } catch(err) {
      console.log(err);
    }
  },
}
</script>

<style scoped>
.stripe-payment-success {
  margin: 100px 0 auto;
  /* border: solid 1px #222222; */
  text-align: center;
  font-size: 30px;
  color: #008000;
  padding: 100px;
  /* background-color: #fefefe; */
}
.stripe-payment-error{
  margin: 100px 0 auto;
  /* border: solid 1px #222222; */
  text-align: center;
  font-size: 20px;
  color: #fc5000;
  padding: 100px;
  line-height: 2;
  /* background-color: #fefefe; */
}

</style>